// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M8.5 7H6.5V11H9V9.5H15V11H17.5V7H15.5V2.5H21.5V7H19.5V17H21.5V21.5H15.5V17H17.5V13H15V14H9V13H6.5V17H8.5V21.5H2.5V17H4.5V7H2.5V2.5H8.5V7Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-mermaid-filled')
export default class MermaidFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mermaid-filled',
    }
  }
}
